<template>
    <div class="animated fadeIn h-100">
        <b-row class="pt-4 px-4 pb-0">
            <b-col md="3" sm="12">
                <b-list-group style="overflow: auto;" class="contentInfo">
                    <b-list-group-item
                        v-for="(item, index) in listData"
                        :key="index"
                        :active="item === selectData"
                        @click="selectData = item"
                        href="#"
                    >
                        {{ `${index + 1}. ${item.name}` }}
                    </b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col md="9" sm="12">
                <b-card style="overflow: auto;" v-html="content" class="p-4 contentInfo"></b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    async mounted() {
        await this.$nextTick();
        this.listData = await this.getList();
        if (this.listData.length > 0) this.selectData = this.listData[0];
    },
    data: function() {
        return {
            listData: [],
            selectData: null,
            content: null
        };
    },
    watch: {
        async selectData(val) {
            const data = await this.getInfo({ id: val.id });
            this.content = data.content;
        }
    },
    methods: {
        ...mapActions({
            getList: 'post/getList',
            getInfo: 'post/getInfo'
        })
    }
};
</script>
<style scoped>
.contentInfo {
    height: calc(100vh - 120px);
}
</style>
